export const generateAuthorizationToken = ({ accessKey, shortName }) => {
    try {
        return `Key ${btoa(`${shortName}:${atob(accessKey)}`)}`
    } catch (error) {
        // console.error(error)
        return ""
    }
}

export const getValueByPath = (object, path) => {
    if (!object)
        return null

    const keys = path.split('.');
    let value = object;

    for (const key of keys) {
        if (value && typeof value === 'object' && key in value) {
            value = value[key];
        } else {
            return null;
        }
    }

    return value;
}

export const replaceVariables = (template, variables) => {
    let type = typeof template

    if (type == "object")
        template = JSON.stringify(type)

    const regex = /{{(.*?)}}/g;

    const replacedString = template.replace(regex, (match, variable) => {
        const trimmedVariable = variable.trim();
        return variables.hasOwnProperty(trimmedVariable) ? variables[trimmedVariable] : match;
    });

    let result = type == "object" ? JSON.parse(replacedString) : replacedString

    return result
}


export const toStringSafe = (value) => {
    if (value === null) return "null";
    if (value === undefined) return "undefined";

    if (typeof value === "string") {
        return value;
    }

    if (
        typeof value === "number" ||
        typeof value === "bigint" ||
        typeof value === "boolean" ||
        typeof value === "symbol"
    ) {
        return String(value);
    }

    if (value instanceof Date) {
        return value.toISOString();
    }

    if (value instanceof Error) {
        return value.stack || value.message;
    }

    if (typeof value === "function") {
        return value.toString();
    }

    // Objetos e arrays
    try {
        return JSON.stringify(value);
    } catch {
        // Objetos com referência circular, por exemplo
        return String(value);
    }
}